import type { FlavorConfig } from '../types';

/**
 * Flavor C Configuration
 * Modern design with glassmorphism effects
 */
export const flavorCConfig: FlavorConfig = {
  id: 'C',
  name: 'Flavor C - Modern',
  className: 'flavor-c',
  description: 'Modern design with glassmorphism, borders, and accent colors',
  styles: {
    borderRadius: '20px',
    cardBackground: 'var(--gradient-card)',
    popupBackground: 'var(--gradient-card)',
    iconBackground: '#f7f7f7',
  },
};

export default flavorCConfig;
